<template>
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item label="物种" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedSpeciesCode',{'initialValue': '20', rules: validatorRules.breedSpeciesCode.rules}]" :trigger-change="true" dictCode="cqlb" placeholder="请选择物种"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="品类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedClassCode',validatorRules.breedClassCode]" :trigger-change="true" dictCode="pzlx" placeholder="请选择品类"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.strain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedStrainCode',validatorRules.breedStrainCode]" :trigger-change="true" dictCode="pxlx" :placeholder="$t('label.pleaseSelectTheStrain')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="放养数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['planBreedQty',validatorRules.planBreedQty]" placeholder="请输入放养数量" style="width: 94%"/> 只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="饲养天数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['breedCycleDays',validatorRules.breedCycleDays]" placeholder="请输入饲养天数" style="width: 94%"/> 天
<!--              <a-input v-decorator="['breedStage',validatorRules.breedStage]" placeholder="请输入饲养天数" style="width: 94%"></a-input> 天-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['breedCycleWeeks',validatorRules.breedCycleWeeks]" placeholder="请输入周期" style="width: 94%"/> 周
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="禽苗单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickPrice',validatorRules.chickPrice]" placeholder="请输入禽苗单价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="标准体重" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdWeight',validatorRules.stdWeight]" placeholder="请输入标准体重" style="width: 89%"/> g/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="标准采食量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdFeedIntake',validatorRules.stdFeedIntake]" placeholder="请输入标准采食量 g" style="width: 89%"/> g/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="毛禽回收标准" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['recoverStandard',validatorRules.recoverStandard]" placeholder="请输入毛禽回收标准 元/斤" style="width: 87%"/> {{ $t('label.rmbKilo') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="疫苗成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['vaccinCost',validatorRules.vaccinCost]" placeholder="请输入疫苗成本" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="兽药成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['drugCost',validatorRules.drugCost]" placeholder="请输入兽药成本" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="饲料成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedCost',validatorRules.feedCost]" placeholder="请输入兽药成本" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="其他成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['othersCost',validatorRules.othersCost]" placeholder="请输入其他成本" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="最低动保单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['minInsurancePrice',validatorRules.minInsurancePrice]" placeholder="请输入最低动保单价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="保证金单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['depositPrice',validatorRules.depositPrice]" placeholder="请输入保证金单价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="计提托养费单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['maintainPrice',validatorRules.maintainPrice]" placeholder="请输入计提托养费单价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="利润分成模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['profitShareMode']" :disabled="profitShareMode" placeholder="请输入利润分成模式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="甲方分成比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['paShareRatio']" :disabled="paShareRatio" placeholder="请输入甲方分成比例" style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="乙方分成比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbShareRatio']" :disabled="pbShareRatio" placeholder="请输入乙方分成比例" style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="乙方分红比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbProfitRatio']" :disabled="pbProfitRatio" placeholder="请输入乙方分红比例" style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.dividendPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['profitPrice']" :disabled="profitPrice" :placeholder="$t('label.pleaseEnterTheDividendPrice')"  style="width: 87%"/> {{ $t('label.rmbKilo') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="单只保值价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['singleHedgePrice']" :disabled="singleHedgePrice" placeholder="请输入单只保值价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="天龄保值价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['daysHedgePrice']" :disabled="daysHedgePrice" placeholder="请输入天龄保值价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="托底价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['floorPrice']" :disabled="floorPrice" placeholder="请输入托底价" style="width: 87%"/> 元/只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="成本对象" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['costCenter']" :trigger-change="true" dictCode="efs_stocking_cost_item,name,code" placeholder="请选择成本对象"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="标准出栏率 " :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdColumnRate']"  placeholder="请输入标准出栏率 " style="width: 94%"/> %
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsMdContractDetailForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
            breedSpeciesCode: {
                rules: [
                    { required: true, message: '请选择物种!'},
                ]
            },
            breedClassCode: {
                rules: [
                    { required: true, message: '请选择品类!'},
                ]
            },
            breedStrainCode: {
                rules: [
                    { required: true, message: '请选择品系!'},
                ]
            },
            planBreedQty: {
                rules: [
                    { required: true, message: '请输入放养数量!'},
                ]
            },
            breedCycleDays: {
                rules: [
                    { required: true, message: '请输入饲养天数!'},
                ]
            },
            breedCycleWeeks: {
                rules: [
                    { required: true, message: '请输入周期!'},
                ]
            },
            chickPrice: {
                rules: [
                    { required: true, message: '请输入禽苗单价!'},
                ]
            },
            stdWeight: {
                rules: [
                    { required: true, message: '请输入标准体重!'},
                ]
            },
            stdFeedIntake: {
                rules: [
                    { required: true, message: '请输入标准采食量!'},
                ]
            },
            recoverStandard: {
                rules: [
                    { required: true, message: '请输入毛禽回收标准!'},
                ]
            },
            vaccinCost: {
                rules: [
                    { required: true, message: '请输入疫苗成本!'},
                ]
            },
            drugCost: {
                rules: [
                    { required: true, message: '请输入兽药成本!'},
                ]
            },
            feedCost: {
              rules: [
                 { required: true, message: '请输入饲料成本!'},
                ]
            },
            othersCost: {
                rules: [
                    { required: true, message: '请输入其他成本!'},
                ]
            },
            minInsurancePrice: {
                rules: [
                    { required: true, message: '请输入最低动保单价!'},
                ]
            },
            depositPrice: {
                rules: [
                    { required: true, message: '请输入保证金单价!'},
                ]
            },
            maintainPrice: {
                rules: [
                    { required: true, message: '请输入计提托养费单价!'},
                ]
            },


        },
        confirmLoading: false,
          profitShareMode:false,
          paShareRatio:false,
          pbShareRatio:false,
          pbProfitRatio:false,
          profitPrice:false,
          singleHedgePrice:false,
          daysHedgePrice:false,
          floorPrice:false,
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("EfsMdContractDetailForm-edit",this.model);
        let fieldval = pick(this.model,'breedSpeciesCode','breedClassCode','breedStrainCode','planBreedQty','breedStage','breedCycleWeeks','chickPrice','stdWeight','stdFeedIntake','recoverStandard','vaccinCost','drugCost','feedCost','othersCost','minInsurancePrice','depositPrice','maintainPrice','profitShareMode','paShareRatio','pbShareRatio','pbProfitRatio','profitPrice','singleHedgePrice','daysHedgePrice','floorPrice','costCenter','stdColumnRate','breedCycleDays')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError","合同明细表单校验未通过");
          }
        })
        console.log("合同明细表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'breedSpeciesCode','breedClassCode','breedStrainCode','planBreedQty','breedStage','breedCycleWeeks','chickPrice','stdWeight','stdFeedIntake','recoverStandard','vaccinCost','drugCost','feedCost','othersCost','minInsurancePrice','depositPrice','maintainPrice','profitShareMode','paShareRatio','pbShareRatio','pbProfitRatio','profitPrice','singleHedgePrice','daysHedgePrice','floorPrice','costCenter','stdColumnRate','breedCycleDays'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
        cooperModeChange(value){
          let cooperMode=value;
           if(cooperMode=="10"){
              this.profitShareMode=false;
              this.paShareRatio=false;
              this.pbShareRatio=false;
              this.pbProfitRatio=false;
              this.profitPrice=false;
              this.singleHedgePrice=true;
              this.daysHedgePrice=true;
              this.floorPrice=false;
              this.form.setFieldsValue({
                   "singleHedgePrice": "","daysHedgePrice":""
               });
           }else if(cooperMode=="20"){
               this.profitShareMode=false;
               this.paShareRatio=false;
               this.pbShareRatio=false;
               this.pbProfitRatio=false;
               this.profitPrice=false;
               this.singleHedgePrice=false;
               this.daysHedgePrice=false;
               this.floorPrice=true;
               this.form.setFieldsValue({
                   "floorPrice": ""
               });
           }else if(cooperMode=="30"){
               this.profitShareMode=true;
               this.paShareRatio=true;
               this.pbShareRatio=true;
               this.pbProfitRatio=true;
               this.profitPrice=true;
               this.singleHedgePrice=false;
               this.daysHedgePrice=false;
               this.floorPrice=true;
               this.form.setFieldsValue({
                   "profitShareMode": "","paShareRatio":"","pbShareRatio":"","pbProfitRatio":"",
                   "profitPrice":"","floorPrice":""
               });
           }else if(cooperMode=="40"){
               this.profitShareMode=true;
               this.paShareRatio=true;
               this.pbShareRatio=true;
               this.pbProfitRatio=true;
               this.profitPrice=true;
               this.singleHedgePrice=true;
               this.daysHedgePrice=true;
               this.floorPrice=false;
               this.form.setFieldsValue({
                   "profitShareMode": "","paShareRatio":"","pbShareRatio":"","pbProfitRatio":"",
                   "profitPrice":"","singleHedgePrice":"","daysHedgePrice":""
               });
           }else if(cooperMode==undefined){
               this.profitShareMode=false;
               this.paShareRatio=false;
               this.pbShareRatio=false;
               this.pbProfitRatio=false;
               this.profitPrice=false;
               this.singleHedgePrice=false;
               this.daysHedgePrice=false;
               this.floorPrice=false;
           }else if(cooperMode=="undefined"){
               this.profitShareMode=false;
               this.paShareRatio=false;
               this.pbShareRatio=false;
               this.pbProfitRatio=false;
               this.profitPrice=false;
               this.singleHedgePrice=false;
               this.daysHedgePrice=false;
               this.floorPrice=false;
           }
        },
    }
  }
</script>
